import { FC, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'

import termsModal from '@/assets/images/popup/terms-modal.svg'
import Popup from '@/common/components/Popup'
import { useTermsModal } from '@/context/TermsContext'
import { Trans, useTranslation } from 'react-i18next'
import { CurrentUser } from '@/api/profile/current-user'

type ProtectedRoutePopUpsProps = { user: CurrentUser }

const ProtectedRoutePopUps: FC<ProtectedRoutePopUpsProps> = ({ user }) => {
  const { pathname } = useLocation()
  const { t } = useTranslation()
  const { showTermsModal, setShowTermsModal, handleAcceptTerms, handleDeclineTerms } = useTermsModal()

  useEffect(() => {
    if (!user.accepted_latest_terms) {
      setShowTermsModal(true)
    }
  }, [user])

  return (
    <Popup
      open={showTermsModal && pathname !== '/account-center'}
      onConfirm={handleAcceptTerms}
      onClose={handleDeclineTerms}
      disableBackdropClick
      buttonLabels={{
        confirm: t('routes.termsPopup.accept'),
        cancel: t('routes.termsPopup.decline'),
      }}
      icon={termsModal}>
      <h4>{t('routes.termsPopup.title')}</h4>
      <Trans
        i18nKey="routes.termsPopup.description"
        components={{
          1: <Link to={'https://cywareness.io/terms-of-service/'} target="_blank" />,
          2: <Link to={'https://cywareness.io/privacy-policy/'} target="_blank" />,
          3: <br />,
        }}
      />
    </Popup>
  )
}

export default ProtectedRoutePopUps
